export const SUMMARY_VIEW_KEY = "All";
